<template>
    <v-row dense align="center" align-content="center" justify="center">
        <v-col cols="12">
            <v-card class="mx-auto">
                <v-card-text dense class="pt-0 pb-0">                            
                    <v-row dense align="center" align-content="center" justify="center">
                        <v-col cols="4">
                            <span class="title"> Dinheiro </span> <br/>
                            <span class="body-2"> A opção de Pagamento em Dinheiro está: <span :class="(quoonDinheiro)?'font-weight-bold green--text':'font-weight-bold red--text'">{{(quoonDinheiro)?'Ativo':'Inativo'}}</span>   </span>                                
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="1">
                            <v-switch v-model="quoonDinheiro" :label="(quoonDinheiro)?'Ativo':'Inativo'" :color="(quoonDinheiro)?'green':'red'" @change="saveConfig('quoonDinheiro',quoonDinheiro)">
                            </v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>   
        </v-col>          
        <v-col cols="12">
            <v-card class="mx-auto">
                <v-card-text dense class="pt-0 pb-0">                            
                    <v-row dense align="center" align-content="center" justify="center">
                        <v-col cols="4">
                            <span class="title"> Cartão de Crédito </span> <br/>
                            <span class="body-2"> A opção de Pagamento por Cartão de Crédito está: <span :class="(quoonCreditCard)?'font-weight-bold green--text':'font-weight-bold red--text'">{{(quoonCreditCard)?'Ativo':'Inativo'}}</span>   </span>                                
                        </v-col>
                        <v-col cols="6">
                            <v-combobox v-model="quoonCredCards" 
                                        :items="creditCards" chips clearable 
                                        label="Selecione os Cartões Aceitos" 
                                        multiple solo hide-details deletable-chips
                                        @change="saveConfig('quoonCreditCard',quoonCreditCard,quoonCredCards,false)"/>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="1">
                            <v-switch v-model="quoonCreditCard" :label="(quoonCreditCard)?'Ativo':'Inativo'" :color="(quoonCreditCard)?'green':'red'" @change="saveConfig('quoonCreditCard',quoonCreditCard,quoonCredCards,true)">
                            </v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>   
        </v-col>  
        <v-col cols="12">
            <v-card class="mx-auto">
                <v-card-text dense class="pt-0 pb-0">                            
                    <v-row dense align="center" align-content="center" justify="center">
                        <v-col cols="4">
                            <span class="title"> Cartão de Débito </span> <br/>
                            <span class="body-2"> A opção de Pagamento por Cartão de Débito está: <span :class="(quoonDebitCard)?'font-weight-bold green--text':'font-weight-bold red--text'">{{(quoonDebitCard)?'Ativo':'Inativo'}}</span>   </span>                                
                        </v-col>
                        <v-col cols="6">
                            <v-combobox v-model="quoonDebitCards" 
                                        :items="debitCards" chips clearable 
                                        label="Selecione os Cartões Aceitos" 
                                        multiple solo hide-details deletable-chips
                                        @change="saveConfig('quoonDebitCard',quoonDebitCard,quoonDebitCards,false)"/>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="1" class="text-right">
                            <v-switch v-model="quoonDebitCard" :label="(quoonDebitCard)?'Ativo':'Inativo'" :color="(quoonDebitCard)?'green':'red'" @change="saveConfig('quoonDebitCard',quoonDebitCard,quoonDebitCards,true)">
                            </v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>   
        </v-col>  
        <v-col cols="12">
            <v-card class="mx-auto">
                <v-card-text dense class="pt-0 pb-0">                            
                    <v-row dense align="center" align-content="center" justify="center">
                        <v-col cols="4">
                            <span class="title"> Cartão de Refeição </span> <br/>
                            <span class="body-2"> A opção de Pagamento por Cartão de Refeição está: <span :class="(quoonRefCard)?'font-weight-bold green--text':'font-weight-bold red--text'">{{(quoonRefCard)?'Ativo':'Inativo'}}</span>   </span>                                
                        </v-col>
                        <v-col cols="6">
                            <v-combobox v-model="quoonRefCards" 
                                        :items="refeicaoCards" chips clearable 
                                        label="Selecione os Cartões Aceitos" 
                                        multiple solo hide-details deletable-chips
                                         @change="saveConfig('quoonRefCard',quoonRefCard,quoonRefCards,false)"/>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="1" class="text-right">
                            <v-switch v-model="quoonRefCard" :label="(quoonRefCard)?'Ativo':'Inativo'" :color="(quoonRefCard)?'green':'red'" @change="saveConfig('quoonRefCard',quoonRefCard,quoonRefCards,true)">
                            </v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>   
        </v-col>         
        <v-col cols="12">
            <v-card class="mx-auto">
                <v-card-text dense class="pt-0 pb-0">                            
                    <v-row dense align="center" align-content="center" justify="center">
                        <v-col cols="4">
                            <span class="title"> Cartão de Alimentação </span> <br/>
                            <span class="body-2"> A opção de Pagamento por Cartão de Alimentação está: <span :class="(quoonAliCard)?'font-weight-bold green--text':'font-weight-bold red--text'">{{(quoonAliCard)?'Ativo':'Inativo'}}</span>   </span>                                
                        </v-col>
                        <v-col cols="6">
                            <v-combobox v-model="quoonAliCards" 
                                        :items="alimentacaoCards" chips clearable 
                                        label="Selecione os Cartões Aceitos" 
                                        multiple solo hide-details deletable-chips
                                        @change="saveConfig('quoonAliCard',quoonAliCard,quoonAliCards,false)"/>                            
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="1" class="text-right">
                            <v-switch v-model="quoonAliCard" :label="(quoonAliCard)?'Ativo':'Inativo'" :color="(quoonAliCard)?'green':'red'" @change="saveConfig('quoonAliCard',quoonAliCard,quoonAliCards,true)">
                            </v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>   
        </v-col>       
        <v-col cols="12">
            <v-card class="mx-auto">
                <v-card-text dense class="pt-0 pb-0">                            
                    <v-row dense align="center" align-content="center" justify="center">
                        <v-col cols="4">
                            <span class="title"> Outros </span> <br/>
                            <span class="body-2"> Outras opções de Pagamento está: <span :class="(quoonOutrosCard)?'font-weight-bold green--text':'font-weight-bold red--text'">{{(quoonOutrosCard)?'Ativo':'Inativo'}}</span>   </span>                                
                        </v-col>
                        <v-col cols="6">
                            <v-combobox v-model="quoonOutrosCards" 
                                        :items="outrosCards" chips clearable 
                                        label="Selecione os Cartões Aceitos" 
                                        multiple solo hide-details deletable-chips
                                        @change="saveConfig('quoonOutrosCard',quoonOutrosCard,quoonOutrosCards,false)"/>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="1" class="text-right">
                            <v-switch v-model="quoonOutrosCard" :label="(quoonOutrosCard)?'Ativo':'Inativo'" :color="(quoonOutrosCard)?'green':'red'" @change="saveConfig('quoonOutrosCard',quoonOutrosCard,quoonOutrosCards,true)">
                            </v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>   
        </v-col>                    
    </v-row>
</template>
<script>
import {db} from '@/main'
import dbFunctions from "@/dbFunctions"
import store from "@/store"
    export default {
        data () {
            return {
                creditCards: ['Visa', 'Mastercard', 'Elo', 'American', 'Hipercard', 'Maestro', 'Express', 'Diners Club', 'GoodCard'],
                debitCards: ['Visa', 'Mastercard', 'Elo', 'Maestro', 'Goodcard'],
                refeicaoCards: ['Alelo', 'Sodexo', 'Ticket', 'VR'],
                alimentacaoCards: ['Alelo', 'Sodexo', 'Ticket', 'VR', 'Sorocred', 'Planvale', 'GreenCard', 'VisaVale'],
                outrosCards: ['Construcard','Alelo Mobilidade', 'Ticket Car'],
                quoonCredCards: '',
                quoonDebitCards: '',
                quoonOutrosCards: '',
                quoonAliCards: '',
                quoonRefCards: '',
                quoonRefCard: false,
                quoonDebitCard: false,
                quoonCreditCard: false,
                quoonOutrosCard: false,
                quoonAliCard: false,
                quoonDinheiro: false
            }
        }, 
        created(){
            this.companyId = this.$store.getters.company.data.id
            this.getDataInfo = dbFunctions.getDataInfo
            this.getCompanyInfo = dbFunctions.getCompanyInfo
            console.log("dataPayment",this.$store.getters.company.data.configPayment)

            if (typeof this.$store.getters.company.data.configPayment.quoonRefCard != 'undefined') {
                this.quoonRefCard = this.$store.getters.company.data.configPayment.quoonRefCard.ativo || false
                this.quoonRefCards = this.$store.getters.company.data.configPayment.quoonRefCard.bandeiras || {}
            }

            if (typeof this.$store.getters.company.data.configPayment.quoonDebitCard != 'undefined') {
                this.quoonDebitCard = this.$store.getters.company.data.configPayment.quoonDebitCard.ativo || false
                this.quoonDebitCards = this.$store.getters.company.data.configPayment.quoonDebitCard.bandeiras
            }

            if (typeof this.$store.getters.company.data.configPayment.quoonCreditCard != 'undefined') {
                this.quoonCreditCard = this.$store.getters.company.data.configPayment.quoonCreditCard.ativo || false
                this.quoonCredCards = this.$store.getters.company.data.configPayment.quoonCreditCard.bandeiras
            }

            if (typeof this.$store.getters.company.data.configPayment.quoonOutrosCard != 'undefined') {
                this.quoonOutrosCard = this.$store.getters.company.data.configPayment.quoonOutrosCard.ativo || false
                this.quoonOutrosCards = this.$store.getters.company.data.configPayment.quoonOutrosCard.bandeiras
            }

            if (typeof this.$store.getters.company.data.configPayment.quoonAliCard != 'undefined') {
                this.quoonAliCard = this.$store.getters.company.data.configPayment.quoonAliCard.ativo || false
                this.quoonAliCards = this.$store.getters.company.data.configPayment.quoonAliCard.bandeiras
            }

            if (typeof this.$store.getters.company.data.configPayment.quoonDinheiro != 'undefined')
                this.quoonDinheiro = this.$store.getters.company.data.configPayment.quoonDinheiro.ativo
        },        
        methods: {
            saveConfig(item, value, flags = null, showMessage = true){
                let configPayment = this.$store.getters.company.data.configPayment || {}
                if (item == 'quoonDinheiro') {
                    configPayment[item] = {
                        'ativo':value
                    }  
                }else{
                    configPayment[item] = {
                        'ativo':value,
                        'bandeiras':flags
                    }  
                }
              
                configPayment = {
                    'configPayment': configPayment
                }                
                console.log(item,value, showMessage, configPayment)

                db.collection('empresas').doc(this.companyId).update(configPayment).then(async() => {
                    this.loading = false
                    let success = {
                        'active':true,
                        'color':'success',
                        'message':'Configuração Atualizada com Sucesso'
                    }                
                    await this.reloadData(this.$store.getters.company.data.id)
                    if (showMessage)
                        this.$emit("loadMessage",success)
                    // this.$emit("listEdit")
                    // this.clearFields()
                }).catch(function (error) {
                    let errorMessage = {
                        'active':true,
                        'color':'error',
                        'message': error
                    }          
                    console.error('Error to Save Config - AttendPage: ' + error)
                    this.$emit("loadMessage",errorMessage)
                })                 
            }, 
            async reloadData(companyId){
                let dataStore = await this.getDataInfo(companyId)
                let empresa = await this.getCompanyInfo(companyId)
              
                store.dispatch("fetchData",dataStore)
                store.dispatch("fetchCompany",empresa)   
            },  
            loadMessage(value){
                this.$emit("loadMessage", value);            
            }
        },               
    }
</script>